export default "__VITE_ASSET__83f4a01c__"